import { Dialog, Transition } from "@headlessui/react";
import { ArchiveIcon, ClipboardCopyIcon, TrashIcon, VolumeOffIcon, VolumeUpIcon, XIcon } from "@heroicons/react/outline";
import { Fragment, useRef } from "react";
import useIFrameView from "../../hooks/useIFrameView";

const BoardSlideLeft = ({
    isOpen,
    isAdmin = false,
    setIsOpen,
    title,
    children,
    setClean,
    onDeleteTask,
    onArchiveTask,
    canEdit = true,
    isArchived = false,
    onRemoveArchiveTask,
    isNewTask = false,
    isActiveNotification = null,
    onChangeNotification,
    zIndexClass = "z-20",
}) => {

    let completeButtonRef = useRef(null)
    const isIFrameView = useIFrameView();

    return (
        <Transition.Root show={isOpen} as={Fragment} initialFocus={completeButtonRef} ref={completeButtonRef}>
            <Dialog as="div" className={`fixed inset-0 overflow-hidden ${zIndexClass}`} onClose={async () => {
                await setClean();
                await setIsOpen(false);
            }}>
                <div className="absolute inset-0 overflow-hidden">

                    <Dialog.Overlay className="fixed inset-0 bg-gray-900 bg-opacity-30 z-5 transition-opacity" />


                    <div className="fixed inset-y-0 xl:pl-16 max-w-full right-0 flex">
                        <Transition.Child
                            as={Fragment}
                            enter="transform transition ease-in-out duration-500 sm:duration-700"
                            enterFrom="translate-x-full"
                            enterTo="translate-x-0"
                            leave="transform transition ease-in-out duration-500 sm:duration-700"
                            leaveFrom="translate-x-0"
                            leaveTo="translate-x-full"
                        >
                            <div className={`w-screen bg-white max-w-4xl${isIFrameView ? " pb-[57px]" : ""}`}>
                                <div className={"h-full divide-y divide-gray-200 flex flex-col shadow"} id={"slideId"}>


                                    <div className={"flex-1 h-0 overflow-y-auto"}>
                                        <div className="py-2 px-4 bg-gray-900 sm:px-6 relative shadow backdrop-blur-sm bg-gray-900">
                                            <div className="flex items-center justify-between">

                                                <div className="flex items-center">


                                                    <Dialog.Title className="text-lg font-medium text-white">{title}</Dialog.Title>


                                                    {
                                                        (!isNewTask && isActiveNotification !== null)  && (
                                                            <button
                                                                type="button"
                                                                className=" rounded-md text-white hover:text-white/70 "
                                                                onClick={async () => {
                                                                    onChangeNotification(!isActiveNotification)
                                                                }}
                                                            >
                                                                <span className="sr-only">Close panel</span>
                                                                {
                                                                    isActiveNotification ? (
                                                                        <VolumeUpIcon className="h-5 w-5 ml-2" aria-hidden="true" />
                                                                    ) : (
                                                                        <VolumeOffIcon className = "h-5 w-5 ml-2" aria-hidden="true" />
                                                                    )
                                                                }
                                                            </button>
                                                        )
                                                    }



                                                </div>


                                                <div className="ml-3 h-7 flex items-center">
                                                    {
                                                        (!isNewTask && isAdmin) && (
                                                            <button
                                                                type="button"
                                                                className=" rounded-md text-white hover:text-white/70 "
                                                                onClick={async () => {
                                                                    onDeleteTask()
                                                                }}
                                                            >
                                                                <span className="sr-only">Close panel</span>
                                                                <TrashIcon className="h-5 w-5 mr-2" aria-hidden="true" />
                                                            </button>
                                                        )
                                                    }

                                                    {
                                                        (!isNewTask && canEdit && !isArchived) && (
                                                            <button
                                                                type="button"
                                                                className=" rounded-md text-white hover:text-white/70 "
                                                                onClick={async () => {
                                                                    await onArchiveTask();
                                                                }}
                                                            >
                                                                <span className="sr-only">Close panel</span>
                                                                <ArchiveIcon className="h-5 w-5 mr-2" aria-hidden="true" />
                                                            </button>
                                                        )
                                                    }



                                                    {
                                                        isArchived && (
                                                            <button
                                                                type="button"
                                                                className=" rounded-md text-white hover:text-white/70 "
                                                                onClick={async () => {
                                                                    await onRemoveArchiveTask();
                                                                }}
                                                            >
                                                                <span className="sr-only">Close panel</span>
                                                                <ClipboardCopyIcon className="h-5 w-5 mr-2" aria-hidden="true" />
                                                            </button>
                                                        )
                                                    }






                                                    <button
                                                        type="button"
                                                        className=" rounded-md text-white hover:text-white/70 "
                                                        onClick={async () => {
                                                            await setClean();
                                                            await setIsOpen(false);
                                                        }}
                                                    >
                                                        <span className="sr-only">Close panel</span>
                                                        <XIcon className="h-5 w-5" aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex-1 flex flex-col justify-between">
                                            <div className={'divide-y divide-gray-200 '}>
                                                {children}
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </Transition.Child>
                    </div>


                </div>
            </Dialog>
        </Transition.Root>
    )
};


export default BoardSlideLeft;
